export default __webpack_public_path__ + "static/how-payments-add8ab43f21b9735ae3552bb7ca9b207.png";